<template>
  <div>
    <template v-if="overTimeRequest.screen === 'approve'">
      <ApprovalDetail :id="id" @ok="handleOk" />
    </template>
    <template v-else>
      <div id="employee-detail">
        <CRow class="row-mobile">
          <CCol class="employees-form">
            <div class="text-center">
              <h4 class="title-header">
                {{ $t("label.label_overtime_infomation") }}
              </h4>
              <div class="note-ot">
                <label>{{ $t("commons.note") }}</label>
                <p class="note">{{ $t("commons.note_time_ot_lunch") }}</p>
                <p class="note">{{ $t("commons.note_time_ot_night") }}</p>
              </div>
            </div>
            <div class="text-content">
              <label>{{ $t("employee.label_employee_code") }}</label>
              <div class="show-text">{{ overTimeRequest.employee_id }}</div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_name") }}</label>
              <div class="show-text">
                {{
                  overTimeRequest.employee ? overTimeRequest.employee.name : ""
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_position") }}</label>
              <div class="show-text">
                {{
                  overTimeRequest.employee
                    ? objectNotNull(overTimeRequest.employee.position)
                      ? overTimeRequest.employee.position.name
                      : ""
                    : ""
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_division") }}</label>
              <div class="show-text">
                {{
                  overTimeRequest.employee &&
                  objectNotNull(overTimeRequest.employee.department)
                    ? overTimeRequest.employee.department.name
                    : ""
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("commons.label_project_name") }}</label>
              <div class="show-text">
                {{
                  overTimeRequest.project ? overTimeRequest.project.name : ""
                }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_over_time_date") }}</label>
              <div class="show-text">
                {{ overTimeRequest.date | formatDate }}
              </div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_date_start") }}</label>
              <div class="show-text">{{ overTimeRequest.start_time }}</div>
            </div>

            <div class="text-content">
              <label>{{ $t("employee.label_employee_date_end") }}</label>
              <div class="show-text">{{ overTimeRequest.end_time }}</div>
            </div>

            <div class="text-content">
              <label>{{ $t("commons.label_total_number_hour") }}</label>
              <div class="show-text">{{ overTimeRequest.duration }}</div>
            </div>

            <div class="text-content">
              <label>{{ $t("commons.label_reason") }}</label>
              <div class="show-text">{{ overTimeRequest.reason }}</div>
            </div>

            <div class="text-content">
              <label>{{ $t("commons.label_status") }}</label>
              <div class="show-text">
                {{
                  $t(
                    `commons.label_status_overtime_request_${overTimeRequest.status}`
                  )
                }}
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="row-mobile">
          <CCol class="employees-form approval-ot">
            <div class="text-label">
              <div class="text-center">
                <h4 class="title-header title-header-mb">
                  {{ $t("overtime.information_approval_ot") }}
                </h4>
              </div>
            </div>
            <div class="text-label-content">
              <div class="table-responsive table-employee-note">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="index">#</th>
                      <th class="create-by">
                        {{ $t("overtime.employee_approval") }}
                      </th>
                      <th class="create-at">
                        {{ $t("overtime.employee_approval_status") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_note") }}
                      </th>
                      <th>
                        {{ $t("overtime.employee_approval_time") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in listEmployeeIdApproval"
                      :key="index"
                    >
                      <th scope="row index">{{ index + 1 }}</th>
                      <td>{{ item.employees[0].name }}</td>
                      <td class="create-at">
                        {{ $t(`overtime.employee_approval_${item.status}`) }}
                      </td>
                      <td class="comment">{{ item.comment }}</td>
                      <td>
                        {{ formatDateOverTime(item.updated_at) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="mobile-row-btn">
          <CCol class="employees-form approval-ot text-center">
            <button
              class="btn btn-success"
              @click="showEditModal"
              v-if="isShowEditBtn"
            >
              <CIcon
                name="cil-pencil"
                style="margin-right: 3px; border: 1px solid #fff"
              ></CIcon>
              {{ $t("button.label_action_edit") }}
            </button>
          </CCol>
        </CRow>
      </div>
    </template>
    <EditOverTimeModal :id="editId" />
    <!-- <CusModal
      @handleCancel="hideApprovalConfirm"
      @handleOk="approveRequest"
      :title="$t('popup.overtime.label_popup_confirm_approve_OT_title')"
      :isShow="isShowApprovalConfirm"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_confirm_title") }}
        </div>
      </div>
    </CusModal> -->
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
import ApprovalDetail from "./ApprovalEmployeeOverTime";
import EditOverTimeModal from "./components/EditOverTimeModal.vue";

export default {
  name: "DetailOverTimeRequest",
  props: ["id"],
  metaInfo() {
    return {
      title: this.$t("page_title.page_overtime_request_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    ApprovalDetail,
    EditOverTimeModal,
  },
  data() {
    return {
      employeeIdApproval1: "",
      employeeIdApproval2: "",
      listEmployeeIdApproval: [],
      editId: null,
      isShowEditBtn: false,
      // isShowApprovalConfirm: false,
    };
  },
  computed: {
    ...mapGetters({
      overTimeRequest: "overtime-request/overTimeRequest",
      flagNotification: "commons/flagNotification",
    }),
  },

  methods: {
    ...mapActions("overtime-request", ["detailOverTimeRequest"]),
    ...mapMutations("commons", ["setNotificationFlag"]),

    showEditModal() {
      this.editId = this.id;
    },

    // hideApprovalConfirm() {
    //   this.isShowApprovalConfirm = false;
    // },

    // showApprovalConfirm() {
    //   this.isShowApprovalConfirm = true;
    // },

    checkShowButtonEdit() {
      const index = this.listEmployeeIdApproval.findIndex(
        (item) => item.status === 1
      );
      if (index >= 0) {
        this.isShowEditBtn = true;
      }
    },

    handleOk() {
      //TODO: handle after approve/reject;
      // this.getShowOverTimeRequest();
    },

    // showApprovalConfirm() {
    //   this.isShowApprovalConfirm = true;
    // },

    async showOverTimeRequest() {
      let overTimeRequestId = this.id;
      await this.detailOverTimeRequest(overTimeRequestId);
    },

    async getShowOverTimeRequest() {
      await this.showOverTimeRequest();
      this.employeeIdApproval1 =
        this.overTimeRequest.over_time_request_approves[0].employee_id;
      if (this.overTimeRequest.over_time_request_approves[1]) {
        this.employeeIdApproval2 =
          this.overTimeRequest.over_time_request_approves[1].employee_id;
      }
      for (let key in this.overTimeRequest.over_time_request_approves) {
        this.listEmployeeIdApproval.push(
          this.overTimeRequest.over_time_request_approves[key]
        );
        if (this.employeeIdApproval1 === this.employeeIdApproval2) {
          break;
        }
      }

      this.setNotificationFlag(false);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },

    formatDateOverTime(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    },
  },

  async created() {
    await this.getShowOverTimeRequest();
    this.checkShowButtonEdit();
  },

  watch: {
    async flagNotification(value) {
      if (value) {
        this.listEmployeeIdApproval = [];
        await this.getShowOverTimeRequest();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1024px) {
  .table {
    width: 550px;
  }
  p.note {
    margin-bottom: 5px;
  }
  .mobile-row-btn {
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 15px !important;
  }
  .row-mobile {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  #employee-detail .employees-form.approval-ot {
    margin-top: 0 !important;
  }
  #employee-detail {
    .employees-form {
      .text-content {
        display: block !important;
        label {
          width: 100% !important;
        }
      }
      .show-text {
        width: 100% !important;
      }
    }
    .title-header {
      margin-bottom: 1rem;
      // margin-top: 25px;
    }
    .title-header-mb {
      margin-top: 0 !important;
    }
  }
}
#employee-detail {
  .note-ot {
    text-align: left;
    p.note {
      font-weight: 700;
      color: #ff1a1a;
    }

    label {
      font-weight: 600;
    }
    margin: 20px 0px;
  }

  .employees-form.approval-ot {
    .text-label h4 {
      color: #3c4b64;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .table-employee-note {
    background-color: white;
    margin-top: 20px;

    th {
      font-size: 15px;
    }

    td {
      color: #3c4b64;
    }

    td.comment {
      max-width: 300px;
      word-wrap: break-word;
    }
  }

  .title-header {
    // border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }

  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;
    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      // margin-bottom: 30px;

      .icon-text-label {
        margin-left: 8px;
      }
    }

    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .image {
        width: 70%;
      }

      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .text-area {
      height: 60px;
    }

    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }

  #toggle-btn {
    height: 37px;
  }
}
</style>
